import { Component, OnInit, Input } from '@angular/core';
import { ViewportScroller } from "@angular/common";
import { EventDetail } from "@biletix/core/models/event/event-detail.model";
import { environment } from "@biletix/env";
import { AbstractionComponent } from "@biletix/core/common/abstraction-component";
import { PerformancePageStateService } from "@biletix/features/performance/services/performance-page-state.service";

@Component({
    selector: 'btx-stay22',
    templateUrl: './stay22.component.html',
    styleUrls: ['./stay22.component.scss'],
    standalone: false
})
export class Stay22Component extends AbstractionComponent implements OnInit {

    eventDetail: EventDetail | any;

    environment = environment;

    stay22Url: string = "";

    @Input() campaignID = '';

    @Input() itemLat = '';

    @Input() itemLong = '';

    @Input() itemVenue = '';



    constructor(private performancePageStateService: PerformancePageStateService,
        private scroller: ViewportScroller) {
        super();

        this.eventDetail = this.performancePageStateService.getEventDetail();



    }

    ngOnInit(): void {

        this.stay22Url = "https://www.stay22.com/embed/gm?aid=biletixticketmasterturkey&campaign=" + this.campaignID + "&maincolor=1F262D&navimage=https://www.biletix.com/static/images/tm-logo-stay22.png&lat=" + this.itemLat + "&lng=" + this.itemLong + "&venue=" + this.itemVenue;
    }
}

